namespace SP {

    export interface OrderLineInfo {
        id: string;
        qty: number;
        hasStock: boolean;
        locationKey: string;
        locationQuantity: number;
        bundleParent: string;
        imageUrl: string;
        description: string;
        extraText: string;
        customerReference: string;
        itemInfo: ItemInfo;
    }


}